import React, { useEffect } from 'react';
import { Routes, Route, useParams, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { gameActions } from '../../actions';

import GameForm from './form';
import GameFormHBP from './form_hbp';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';
import { GameLeaderboard } from './leaderboard';

// Sim-specific
import GameDancefloor from './dancefloor';
import GameSatisfaction from './satisfaction';
import GameBargaining from './bargaining';
import GameFirst from './first';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  useEffect(() => {
    dispatch(gameActions.fetchGames(id));
  }, [dispatch, id]);

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameFormHBP
      : GameForm;

  // Location validations
  const { pathname } = window.location;
  const isSaved = game?.data?.status === 'saved';

  // When saved: Useful when creating a new run (snapshot)
  const redirectWhenSaved = ['/players', '/debrief'];
  if (isSaved && redirectWhenSaved.some((s) => pathname.includes(s))) {
    return <Navigate to={'/games/' + game?.data?._id} />;
  }

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />
            <Route path='debrief/overview' element={<GameDebrief />} />

            {/* Sim-specific */}
            <Route
              exact
              path={'/debrief/dancefloor'}
              element={<GameDancefloor />}
            />
            <Route
              exact
              path={'/debrief/satisfaction'}
              element={<GameSatisfaction />}
            />
            <Route
              exact
              path={'/debrief/bargaining'}
              element={<GameBargaining />}
            />
            <Route exact path={'/debrief/first'} element={<GameFirst />} />
            <Route
              exact
              path={'/debrief/leaderboard'}
              element={<GameLeaderboard />}
            />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
